import api from '../services/api';

class CertificateModel {
  constructor() {
    this.certificates = [];
    this.currentCertificate = null;
    this.loading = false;
    this.stats = null;
  }

  async issueCertificate(certificateData) {
    try {
      this.loading = true;
      const response = await api.post('/certificates/issue', certificateData);
      return { success: true, data: response.data.data };
    } catch (error) {
      return { 
        success: false, 
        message: error.response?.data?.message || 'Failed to issue certificate' 
      };
    } finally {
      this.loading = false;
    }
  }

  async getMyCertificates() {
    try {
      this.loading = true;
      const response = await api.get('/certificates/my-certificates');
      this.certificates = response.data.data.certificates;
      return this.certificates;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch certificates');
    } finally {
      this.loading = false;
    }
  }

  async getCertificateById(id) {
    try {
      this.loading = true;
      const response = await api.get(`/certificates/${id}`);
      this.currentCertificate = response.data.data.certificate;
      return this.currentCertificate;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch certificate');
    } finally {
      this.loading = false;
    }
  }

  async verifyCertificate(id) {
    try {
      const response = await api.get(`/verify/certificate/${id}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Verification failed');
    }
  }

  async verifyByHash(hash) {
    try {
      const response = await api.get(`/verify/hash/${hash}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Verification failed');
    }
  }

  async verifyByQR(qrData) {
    try {
      const response = await api.post('/verify/qr-code', { qrData });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Verification failed');
    }
  }

  async getVerificationStats() {
    try {
      const response = await api.get('/verify/statistics');
      this.stats = response.data.data.stats;
      return this.stats;
    } catch (error) {
      throw new Error('Failed to fetch statistics');
    }
  }

  getStatusBadgeClass(status) {
    const statusClasses = {
      MINTED: 'badge-success',
      PENDING: 'badge-warning',
      REVOKED: 'badge-error',
      VERIFIED: 'badge-success'
    };
    return `badge ${statusClasses[status] || 'badge-info'}`;
  }

  formatDate(dateString) {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }
}

export default new CertificateModel();